export const EvolutionGames = {
  CrazyTime: {
    redirectUrl: "/casino/ezgevo-crazy-time",
    code: "1000148",
    casino: "ezugi",
    provider: "Evolution",
    homeUrl: "http://localhost:3000/Casino",
    imgUrl: "./images/evolution/crazytime-Evo.jpg",
    alt: "Crazy Time",
    name: "Crazy Time",
    providerName: "Evolution",
  },
  SpeedRoulette: {
    redirectUrl: "/casino/ezgevo-speed-roulette",
    code: "1000148",
    casino: "ezugi",
    provider: "",
    homeUrl: "http://localhost:3000/Casino",
    imgUrl: "./images/evolution/SpeedRoulette.jpg",
    alt: "",
    name: "Speed Roulette",
    providerName: "Evolution",
  },
  SuperAndarbahar: {
    code: "98789",
    casino: "ezugi",
    provider: "Evolution",
    homeUrl: "http://localhost:3000/Casino",
    alt: "super Andar bahar",
    name: "Super Andar Bahar",
    providerName: "Evolution",
    imgUrl: "./images/evolution/superAndharBahar.jpg",
    redirectUrl: "/casino/aggapevolutiongaming-super-andar-bahar",
  },
  DragonTiger: {
    code: "98790",
    casino: "ezugi",
    provider: "Evolution",
    homeUrl: "http://localhost:3000/Casino",
    alt: "Dragon Tiger",
    name: "Dragon Tiger",
    providerName: "Evolution",
    imgUrl: "./images/evolution/DragonTiger.jpg",
    redirectUrl: "/casino/ezgevo-dragon-tiger-evo",
  },
  lightningsicbo: {
    redirectUrl: "/casino/ezgevo-gonzos-lightning-sic-bo",
    code: "227103",
    casino: "ezugi",
    provider: "",
    homeUrl: "http://localhost:3000/Casino",
    imgUrl: "./images/popular/lightningsicbo.webp",
    alt: "",
    name: "Lightning Sic Bo",
    providerName: "Evolution",
  },
  SpeedCricketBaccarat: {
    redirectUrl: "/casino/ezgevo-speed-baccarat-x",
    code: "101",
    casino: "ezugi",
    provider: "",
    homeUrl: "http://localhost:3000/Casino",
    imgUrl: "./images/baccarat/SpeedBaccaratx.webp",
    alt: "",
    name: "Speed Baccarat X",
    providerName: "Evolution",
  },
  BlackjackSilverD: {
    redirectUrl: "/casino/ezgevo-blackjack-silver-d",
    code: "1000044",
    casino: "ezugi",
    provider: "",
    homeUrl: "http://localhost:3000/Casino",
    imgUrl: "./images/blackjack/Blackjack-Silver-D.webp",
    alt: "",
    name: "Blackjack Silver D",
    providerName: "Evolution",
  },
  BlackjackVIPE: {
    redirectUrl: "/casino/ezgevo-blackjack-vip-e",
    code: "1000052",
    casino: "ezugi",
    provider: "",
    homeUrl: "http://localhost:3000/Casino",
    imgUrl: "./images/blackjack/Blackjack-VIP-E.webp",
    alt: "",
    name: "Blackjack VIP E",
    providerName: "Evolution",
  },
  // SpeedBlackjackD: {
  //   redirectUrl: "/casino/aggapevolutiongaming-speed-blackjack-d",
  //   code: "1000033",
  //   casino: "ezugi",
  //   provider: "",
  //   homeUrl: "http://localhost:3000/Casino",
  //   imgUrl: "./images/blackjack/Speed-Blackjack-D1.webp",
  //   alt: "",
  //   name: "Speed Blackjack D",
  //   providerName: "Evolution",
  // },
  BlackjackVIPL: {
    redirectUrl: "/casino/ezgevo-blackjack-vip-l",
    code: "1000056",
    casino: "ezugi",
    provider: "",
    homeUrl: "http://localhost:3000/Casino",
    imgUrl: "./images/blackjack/Blackjack-VIP-L.webp",
    alt: "",
    name: "Blackjack VIP L",
    providerName: "Evolution",
  },
  Autoroulette: {
    code: "56768",
    casino: "ezugi",
    provider: "Evolution",
    homeUrl: "http://localhost:3000/Casino",
    alt: "Auto Roulette",
    name: "Auto Roulette",
    providerName: "Evolution",
    imgUrl: "./images/evolution/Autoroulette.jpg",
    redirectUrl: "/casino/ezg-auto-roulette",
  },
  ClassicSpeedBlackjack3: {
    redirectUrl: "/casino/ezgevo-classic-speed-blackjack-3",
    code: "1000228",
    casino: "ezugi",
    provider: "",
    homeUrl: "http://localhost:3000/Casino",
    imgUrl: "./images/blackjack/Speed-Blackjack-3.webp",
    alt: "",
    name: " Classic Speed Blackjack 3  ",
    providerName: "Evolution",
  },
  Hand2CasinoHoldem: {
    redirectUrl: "/casino/ezgevo-2-hand-casino-holdem",
    code: "1000073",
    casino: "ezugi",
    provider: "",
    homeUrl: "http://localhost:3000/Casino",
    imgUrl: "./images/poker/2handcasinoholem.webp",
    alt: "",
    name: " 2 Hand Casino Holdem",
    providerName: "Evolution",
  },
  TexasHoldembonus: {
    redirectUrl: "/casino/ezgevo-texas-holdem-bonus-poker",
    code: "1000111",
    casino: "ezugi",
    provider: "",
    homeUrl: "http://localhost:3000/Casino",
    imgUrl: "./images/poker/TexasHoldembonus.webp",
    alt: "",
    name: "Texas Holdem Bonus",
    providerName: "Evolution",
  },
};
